import { createContext } from 'react';
import { createASpoolType } from './createASpoolType';

const CreateASpoolContext = createContext({} as createASpoolType);

export default CreateASpoolContext;
